import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-img_data_blue",
  "use": "icon-img_data_blue-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon-img_data_blue\"><path d=\"M28.897 7.176C13.473 7.176.97 19.679.97 35.103S13.473 63.03 28.897 63.03s27.927-12.503 27.927-27.927H28.897V7.176ZM35.103.97C50.527.97 63.03 13.473 63.03 28.897H35.103V.97Z\" fill=\"#F2FBFF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol